import script from "./icon-multiple-users.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-multiple-users.vue?vue&type=script&lang=ts&setup=true"

import "./icon-multiple-users.vue?vue&type=style&index=0&id=4e8abad8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e8abad8"]])

export default __exports__